import { z } from "zod";

// Create an affiliate network ("source"). `tracking_config` is freeform JSON sent as a string
// (contract {"sub_id_param": "..."}) and parsed to jsonb at the controller boundary. String bounds
// mirror the V003 column widths (code VARCHAR(50), name VARCHAR(200)).
export const createProductSourceRequestSchema = z.object({
  code: z.string().min(1, "Code is required").max(50),
  name: z.string().min(1, "Name is required").max(200),
  tracking_config: z.string().nullable().optional(),
  active: z.boolean().optional(),
});
